import { put, fork, takeEvery } from 'redux-saga/effects';

import { prompt, showPrompt } from './slice';
import watcher from './saga';

const makeWithPrompt =
    <T extends ReadonlyArray<any>>(success: boolean | null) =>
    (testSaga: (...args: T) => any) =>
        function* (...args: T) {
            yield fork(watcher);
            if (success !== null) {
                yield takeEvery(showPrompt.type, function* () {
                    yield put(success ? prompt.success() : prompt.failure());
                });
            }
            yield testSaga(...args);
        };

export default {
    trigger: makeWithPrompt(null),
    success: makeWithPrompt(true),
    failure: makeWithPrompt(false),
};
